import React, { useState } from "react";
import flightIcon from "../assets/icons/flight.svg";

import { FaCheckCircle } from "react-icons/fa";
import { FaDollarSign } from "react-icons/fa";
import { FaSyncAlt } from "react-icons/fa";
import Bag from "../assets/icons/bag.svg";
import Chair from "../assets/icons/chair.svg";
import Amenity from "../assets/icons/aminity.svg";
import { formatPrice } from "../utils/flightDataUtils";
import Amenities from "./Amenities";

function DoubleRateCard(props) {
  const [showDetails, setShowDetails] = useState(false); // Don't show details initially
  const [activeTab, setActiveTab] = useState("Best");

  const [hoveredCard, setHoveredCard] = useState(null); // Track which card is being hovered
  const [checkedFlights, setCheckedFlights] = useState(new Set()); // Track which flights are checked
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);

  // Function to map flight data amenities to Amenities component format
  const mapFlightAmenities = (flightAmenities = []) => {
    const amenityMapping = {
      'WiFi': 'wifi',
      'Entertainment': 'entertainment', 
      'Refreshments': 'meal',
      'Meals': 'meal',
      'Power': 'power'
    };
    
    return flightAmenities.map(amenity => amenityMapping[amenity]).filter(Boolean);
  };

  // Use props data instead of hardcoded data
  const airlineImg =
    props.airlineImg ||
    "https://content.r9cdn.net/rimg/provider-logos/airlines/v/B6.png?crop=false&width=108&height=92&fallback=default1.png&_v=1d9c582b6d8f9aebe5ff965c9bb916ee";

  // Create flights array from props data
  const flights = [
    {
      time: props.time || "09:10 - 18:00",
      route: props.route || "BLR Bengaluru Intl-SFO San Francisco",
      stops: props.flightType || "1 stop",
      stopAirport: "BOM",
      duration: props.duration || "21h 20m",
      airline: props.airlineName || "Air India",
      flightNumber: "AI 123",
      aircraft: "Airbus A320neo",
      amenities: props.amenities || ["WiFi", "Entertainment", "Refreshments"],
      departure: {
        time: props.time ? props.time.split(" – ")[0] : "09:10",
        airport: props.route
          ? props.route.split("-")[0]
          : "Bengaluru Intl (BLR)",
        code: props.route
          ? props.route.split("-")[0].split(" ").pop().replace(/[()]/g, "")
          : "BLR",
      },
      arrival: {
        time: props.time ? props.time.split(" – ")[1] : "18:00",
        airport: props.route
          ? props.route.split("-")[1]
          : "San Francisco (SFO)",
        code: props.route
          ? props.route.split("-")[1].split(" ").pop().replace(/[()]/g, "")
          : "SFO",
      },
      flightDuration: props.duration || "21h 20m"
    }
  ];

  // Add return flight if available
  if (props.returnTime && props.returnRoute && props.returnDuration) {
    flights.push({
      time: props.returnTime,
      route: props.returnRoute,
      stops: props.returnFlightType || "1 stop",
      stopAirport: "Return stop",
      duration: props.returnDuration,
      airline: props.airlineName || "Air India",
      flightNumber: props.returnFlightNumber || "Return flight number",
      aircraft: props.returnAircraft || "Return aircraft",
      amenities: props.returnAmenities || ["WiFi", "Entertainment"],
      departure: {
        time: props.returnTime
          ? props.returnTime.split(" – ")[0]
          : "Return departure time",
        airport: props.returnRoute
          ? props.returnRoute.split("-")[0]
          : "Return departure airport",
        code: props.returnRoute
          ? props.returnRoute
            .split("-")[0]
            .split(" ")
            .pop()
            .replace(/[()]/g, "")
          : "Return departure code",
      },
      arrival: {
        time: props.returnTime
          ? props.returnTime.split(" – ")[1]
          : "Return arrival time",
        airport: props.returnRoute
          ? props.returnRoute.split("-")[1]
          : "Return arrival airport",
        code: props.returnRoute
          ? props.returnRoute
            .split("-")[1]
            .split(" ")
            .pop()
            .replace(/[()]/g, "")
          : "Return arrival code",
      },
      flightDuration: props.returnDuration,
    });
  }

  const handleFlightDetailsClick = () => {
    // Toggle details for both flights
    setShowDetails(!showDetails);
  };

  const handleCheckboxClick = (index, e) => {
    e.stopPropagation(); // Prevent event bubbling to flight details
    const newCheckedFlights = new Set(checkedFlights);
    if (newCheckedFlights.has(index)) {
      newCheckedFlights.delete(index);
    } else {
      newCheckedFlights.add(index);
    }
    setCheckedFlights(newCheckedFlights);
  };



  return (
    <div style={{
      background: '#fff',
      borderRadius: 10,
      boxShadow: '0 2px 8px #dbe2ea',
      border: '1px solid #cfd8e3',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      overflow: 'hidden',
      margin: '10px 0',
    }}>
      {/* Best inline ad header (only for the very first card when Best is selected) */}
      {props.showBestHeader && (
        <div style={{
          display: 'flex',
          alignItems: 'stretch',
          backgroundColor: '#fff',
          border: '1px solid #E6EBEF',
          borderRadius: 10,
          margin: '0px 0px 0px',
          padding: '12px',
          gap: 16,
          position: 'relative'
        }}>
          {/* Left strip */}
          <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, backgroundColor: '#1a73e8', borderTopLeftRadius: 10, borderBottomLeftRadius: 10 }} />

          {/* Left: logo + text */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingLeft: 12, flex: 1 }}>
            <img
              src={airlineImg}
              alt={props.airlineName || 'Airline'}
              style={{ height: 20, objectFit: 'contain' }}
            />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 800, color: '#1b1f23', fontSize: 16 }}>Find the best deals on eDreams</div>
              <div style={{ color: '#667085', fontSize: 13 }}>Compare flights from more than 600 airlines</div>
            </div>
          </div>

          {/* Right: price panel */}


          {/* Ad label */}
          <div style={{ position: 'absolute', right: 16, bottom: 8, color: '#6b7280', fontSize: 12 }}>Ad</div>
        </div>
      )}

      {/* Main Content */}

        <div style={{ display: 'flex', alignItems: 'stretch', gap: 0 , padding: '0 5px'  }}>
        {/* Left: Flight Details */}
        <div style={{ flex: 2, padding: '4px 14px', display: 'flex', flexDirection: 'column', gap: 0 }}>
          {/* Top Header Section */}
          <div style={{ padding: "8px 0px " }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* Left Side - Action Buttons */}
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={props.onSave} style={{
                  border: '1px solid #9ba8b0',
                  background: '#f9fafb',
                  borderRadius: 6,
                  padding: '3px 8px',
                  fontWeight: 700,
                  fontSize: 12,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  cursor: 'pointer'
                }}>
                  <svg
                    viewBox="0 0 200 200"
                    width="1.25em"
                    height="1.25em"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="Save"
                    role="presentation"
                  >
                    <path d="M58.67 36.78h0c13.42 0 22.91 8.58 28.5 15.78l9.87 12.71a4.163 4.163 0 006.58 0l9.87-12.71c5.59-7.2 15.07-15.78 28.49-15.78c.5 0 1 .01 1.52.03c7.96.35 15.45 3.73 21.1 9.52c5.62 5.76 8.72 13.28 8.72 21.19c0 14.73-9.73 33.18-28.14 53.34c-16.52 18.08-31 31.94-44.12 42.26c-.43.33-.65.33-.73.33c-.08 0-.39-.07-.52-.16c-13.58-10.76-28.08-24.63-44.33-42.42c-18.41-20.16-28.15-38.61-28.15-53.34c0-7.9 3.1-15.43 8.72-21.19c5.65-5.79 13.14-9.17 21.11-9.52c.51-.02 1.01-.03 1.5-.03m83.32-16.67c-20.29 0-34.08 12.46-41.66 22.22c-7.58-9.76-21.37-22.22-41.66-22.22c-.74 0-1.5.02-2.26.05c-12.27.54-23.68 5.7-32.29 14.53c-8.72 8.93-13.45 20.56-13.45 32.83c0 19.27 10.98 41.01 32.51 64.58c17.11 18.73 32.29 33.15 46.28 44.24c3.23 2.48 7.1 3.77 10.87 3.77s7.64-1.29 10.87-3.77c14.1-11.09 29.17-25.51 46.28-44.24c21.53-23.57 32.51-45.32 32.51-64.58c0-12.27-4.74-23.9-13.46-32.83c-8.61-8.83-20.13-13.99-32.29-14.53c-.76-.03-1.51-.05-2.26-.05h0z"></path>
                  </svg>{" "}
                  Save
                </button>
                <button onClick={props.onShare} style={{
                  border: '1px solid #9ba8b0',
                  background: '#f9fafb',
                  borderRadius: 6,
                  padding: '3px 8px',
                  fontWeight: 700,
                  fontSize: 12,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  cursor: 'pointer'
                }}>
                  <svg
                    viewBox="0 0 200 200"
                    width="1.25em"
                    height="1.25em"
                    xmlns="http://www.w3.org/2000/svg"
                    role="presentation"
                  >
                    <path d="M182 109.42l-10.75 10.75c0 .08-.08.17-.17.25L127.58 164l-10.92 11H99.99v-40.92c-44.87 2.76-65.8 16.52-75.43 27.33c-3.08 3.46-8.81 1.09-8.68-3.55c.79-28.41 11.87-82.89 84.1-90.12V25h16.67l10.92 11l43.5 43.58c.08.08.17.17.17.25l10.75 10.75c5.25 5.17 5.25 13.67 0 18.83z"></path>
                  </svg>{" "}
                  Share
                </button>
              </div>

              {/* Right Side - Tabs */}
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => setActiveTab("Best")}
                  style={{
                    background: activeTab === "Best" ? '#e3f2fd' : '#f5f5f5',
                    color: activeTab === "Best" ? '#1976d2' : '#666',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    fontWeight: 600,
                    fontSize: 14,
                    cursor: 'pointer',
                    display: 'none',
                  }}
                >
                  Best
                </button>


              </div>
            </div>
          </div>
          {/* Flight Rows */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', position: 'relative' }}>
            {/* Checkboxes positioned outside hover area */}
            {flights.map((f, i) => (
              <div
                key={`checkbox-${i}`}
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: i === 0 ? '32px' : `${i * 90}px`,
                  transform: 'translate(calc((16px - 44px) / 2), calc((16px - 44px) / 2))',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '24px',
                  height: '24px',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  zIndex: 2,
                  // display: 'flex', 
                  // alignItems: 'center', 
                  // justifyContent: 'center',
                  // width: '24px',
                  // height: '24px',
                  // backgroundColor: 'white',
                  // borderRadius: '4px',
                  // zIndex: 2,
                }}
              >
                <input
                  type="checkbox"
                  checked={checkedFlights.has(i)}
                  onChange={(e) => handleCheckboxClick(i, e)}
                  style={{
                    width: '16px',
                    height: '16px',
                    margin: 0,
                    cursor: 'pointer',
                    backgroundColor: 'white',
                  }}
                />
              </div>
            ))}

            {/* Flight details with unified hover effect */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '8px 12px',
                borderRadius: '6px',
                transition: 'background-color 0.2s',
                cursor: 'pointer',
                marginLeft: '36px', // Space for checkboxes
              }}
              onClick={handleFlightDetailsClick}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = " #E6EBEF";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              {flights.map((f, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    width: '100%',
                  }}
                >
                  {/* Flight details - inside unified hover area */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    flex: 1,
                    width: '100%',
                  }}>
                    {/* Airline Logo */}
                    <img src={airlineImg} alt={props.airlineName || "Air India"} style={{ width: 40, height: 32, objectFit: 'contain' }} />

                    {/* Flight Times & Route */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '2px' }}>
                      <div style={{ fontWeight: 700, fontSize: 16, color: '#222' }}>
                        {f.time}
                      </div>
                      <div style={{ fontSize: 14, color: '#666' }}>
                        {f.airline}
                      </div>
                    </div>

                    {/* Stops & Stop Airport */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', minWidth: '60px' }}>
                      <div style={{ fontWeight: 700, fontSize: 14, color: '#222' }}>
                        {f.stops}
                      </div>
                      {f.stops !== "nonstop" && (
                        <div style={{ fontSize: 14, color: '#666' }}>
                          {f.stopAirport}
                        </div>
                      )}
                    </div>

                    {/* Duration */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px', minWidth: '80px' }}>
                      <div style={{ fontWeight: 700, fontSize: 16, color: '#222' }}>
                        {f.duration}
                      </div>
                      <div style={{ fontSize: 14, color: '#666' }}>
                        {f.route}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>


        </div>

        {/* Pricing Cards */}
        <div style={{ display: 'flex', margin: "20px 0", gap: '8px',  }}>
          {/* Left Card (Selected) */}
          <div
            style={{
              background: hoveredCard === 'left' ? '#E6EBEF' : '#fff',
              borderRadius: '12px',
              border: "1px solid #cfd8e3",
              width: '168px',
              textAlign: 'start',
              boxShadow: hoveredCard === 'left' ? '0 4px 12px rgba(25, 118, 210, 0.15)' : '0 2px 8px rgba(0,0,0,0.05)',
              cursor: 'pointer',
            }}
            onMouseEnter={() => setHoveredCard('left')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ fontWeight: 700, fontSize: 24, color: '#222', marginBottom: '4px', marginLeft: "10px" }}>
              {props.price1 || '$819'}
            </div>
            <div style={{ fontSize: 12, color: '#444', marginBottom: '8px', marginLeft: "10px" }}>
              Basic<br />Southwest
            </div>

            <button style={{
              background: 'linear-gradient(135deg,#ff690f 0%,#e8381b 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 16px',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
              width: '80%',
              marginBottom: '10px',
              marginLeft: "10px",
              transition: 'none',
              transform: 'none'
            }}>
              {props.showBestHeader ? 'View deal' : 'Select'}
            </button>

            <hr style={{ margin: '10px 0', border: "1px solid #cfd8e3" }} />

            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <div>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15v-60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V85h15a15 15 0 0115 15v60a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5v-60a5 5 0 00-5-5H55a5 5 0 00-5 5v60a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm0-80h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 60a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5zm-50 0a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5z"></path></svg>
                <FaCheckCircle size={12} color="green" />
              </div>
              <div>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15V60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V45h15a15 15 0 0115 15v100a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5V60a5 5 0 00-5-5H80v12.93l8.54 8.53A5 5 0 0190 80v30a5 5 0 01-5 5h-5v25a5 5 0 01-10 0v-25h-5a5 5 0 01-5-5V80a5 5 0 011.46-3.54L70 67.93V55H55a5 5 0 00-5 5v100a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm-10-60h10V82.07l-5-5l-5 5zm10-60h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 100a5 5 0 01-5-5V80a5 5 0 0110 0v60a5 5 0 01-5 5z"></path></svg>
                <FaDollarSign size={12} color="#333" />
              </div>
              <div>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M135 180H75a5 5 0 010-10h25v-20H75a5 5 0 01-4.85-3.79l-10-39.89l-.06-.21l-10-39.9A4.89 4.89 0 0150 65V35a15 15 0 0130 0v29.38L88.9 100H145a5 5 0 010 10H91.4l2.5 10H135a15 15 0 0115 15v10a5 5 0 01-5 5h-35v20h25a5 5 0 010 10zm-30-40h35v-5a5 5 0 00-5-5H90a5 5 0 01-4.85-3.79L81.1 110h-9.7l7.5 30zm-36.1-40h9.7l-8.45-33.79A4.89 4.89 0 0170 65V35a5 5 0 00-10 0v29.38z"></path></svg>
                <FaSyncAlt size={12} color="green" />
              </div>
            </div>
          </div>

          {/* Right Card (Preferred) */}
          <div
            style={{
              background: hoveredCard === 'right' ? '#E6EBEF' : '#fff',
              borderRadius: '12px',
              border: "1px solid #cfd8e3",
              width: '168px',
              textAlign: 'start',
              boxShadow: hoveredCard === 'right' ? '0 4px 12px rgba(25, 118, 210, 0.15)' : '0 2px 8px rgba(0,0,0,0.05)',
              cursor: 'pointer',
            }}
            onMouseEnter={() => setHoveredCard('right')}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div style={{ fontWeight: 700, fontSize: 24, color: '#222', marginBottom: '4px', marginLeft: "10px" }}>
              {props.price2 || '$819'}
            </div>
            <div style={{ fontSize: 12, color: '#444', marginBottom: '8px', marginLeft: "10px" }}>
              Choice<br />Southwest
            </div>

            <button style={{
              background: 'linear-gradient(135deg,#ff690f 0%,#e8381b 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              padding: '8px 16px',
              fontWeight: 600,
              marginLeft: "10px",
              fontSize: 14,
              cursor: 'pointer',
              width: '80%',
              marginBottom: '10px',
              transition: 'none',
              transform: 'none'
            }}>
              {props.showBestHeader ? 'View deal' : 'Select'}
            </button>

            <hr style={{ margin: '10px 0' }} />

            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <div>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15v-60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V85h15a15 15 0 0115 15v60a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5v-60a5 5 0 00-5-5H55a5 5 0 00-5 5v60a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm0-80h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 60a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5zm-50 0a5 5 0 01-5-5v-20a5 5 0 0110 0v20a5 5 0 01-5 5z"></path></svg>
                <FaCheckCircle size={14} color="green" />
              </div>
              <div>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M130 185a15 15 0 01-14.14-10H84.14a15 15 0 01-28.28 0H55a15 15 0 01-15-15V60a15 15 0 0115-15h15V27.12C70 22.6 73.9 15 100 15c11.2 0 30 1.58 30 12.12V45h15a15 15 0 0115 15v100a15 15 0 01-15 15h-.86A15 15 0 01130 185zm-50-20h40a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5h5a5 5 0 005-5V60a5 5 0 00-5-5H80v12.93l8.54 8.53A5 5 0 0190 80v30a5 5 0 01-5 5h-5v25a5 5 0 01-10 0v-25h-5a5 5 0 01-5-5V80a5 5 0 011.46-3.54L70 67.93V55H55a5 5 0 00-5 5v100a5 5 0 005 5h5a5 5 0 015 5a5 5 0 0010 0a5 5 0 015-5zm-10-60h10V82.07l-5-5l-5 5zm10-60h40V28.1c-2-1.23-8.93-3.1-20-3.1s-18 1.87-20 3.1zm45 100a5 5 0 01-5-5V80a5 5 0 0110 0v60a5 5 0 01-5 5z"></path></svg>
                <FaDollarSign size={14} color="#333" />
              </div>
              <div>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" role="presentation"><path d="M135 180H75a5 5 0 010-10h25v-20H75a5 5 0 01-4.85-3.79l-10-39.89l-.06-.21l-10-39.9A4.89 4.89 0 0150 65V35a15 15 0 0130 0v29.38L88.9 100H145a5 5 0 010 10H91.4l2.5 10H135a15 15 0 0115 15v10a5 5 0 01-5 5h-35v20h25a5 5 0 010 10zm-30-40h35v-5a5 5 0 00-5-5H90a5 5 0 01-4.85-3.79L81.1 110h-9.7l7.5 30zm-36.1-40h9.7l-8.45-33.79A4.89 4.89 0 0170 65V35a5 5 0 00-10 0v29.38z"></path></svg>
                <FaSyncAlt size={14} color="green" />
              </div>
            </div>
          </div>

        </div>

      </div>

      {/* Flight Details Section - Show both departure and return */}
      {showDetails && (
        <>
          {/* Container with light grey background */}
          <div style={{
            background: '#f8f9fa',
            padding: '16px',
            margin: '10px',
            borderRadius: '10px'
          }}>
            {/* Departure Card */}
            <div style={{
              background: '#fff',
              borderRadius: 10,
              boxShadow: '0 2px 8px #dbe2ea',
              border: '1px solid #cfd8e3',
              padding: "16px",
              marginBottom: '12px'
            }}>
              {/* Departure Header */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '16px',
                padding: '0',
                borderBottom: '1px solid #dee2e6'
              }}>
                <div style={{ fontWeight: 600, fontSize: 16, color: '#333' }}>
                  Depart • {flights[0].departure.airport} to {flights[0].arrival.airport}
                </div>
                <div style={{ fontWeight: 600, fontSize: 14, color: '#666' }}>
                  {flights[0].flightDuration}
                </div>
              </div>

              {/* Departure Flight Segment */}
              <div style={{
                marginBottom: '0',
                position: 'relative'
              }}>
                {/* Flight Header */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '16px'
                }}>
                  <span style={{
                    color: '#0074d9',
                    fontWeight: 600,
                    fontSize: 14
                  }}>
                    {flights[0].airline}
                  </span>
                  <span style={{ fontSize: 12, color: '#5a6872' }}>
                    {flights[0].flightNumber}
                  </span>
                  <span style={{
                    color: '#666',
                    padding: '4px 12px',
                    borderRadius: '8px',
                    fontSize: 12,
                    fontWeight: 500,
                    border: "1px solid #cfd8e3",
                    marginLeft: "10px",
                  }}>
                    {flights[0].aircraft}
                  </span>

                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'center', position: 'absolute', right: '0', top: '0' }}>
                    <Amenities amenities={mapFlightAmenities(flights[0].amenities)} cabinClass="Basic Economy" /> 
                  </div>
                </div>

                {/* Vertical Timeline Layout */}
                <div style={{
                  position: 'relative',
                  paddingLeft: '30px'
                }}>
                  {/* Timeline Line */}
                  <div style={{
                    position: 'absolute',
                    left: '14px',
                    top: '0',
                    bottom: '0',
                    width: '2px',
                    background: '#ddd'
                  }}></div>

                  {/* Departure */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '16px'
                  }}>
                    {/* Timeline Circle */}
                    <div style={{
                      position: 'absolute',
                      left: '-21px',
                      top: '0px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      border: '2px solid #ddd',
                      background: '#fff'
                    }}></div>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                      <div style={{ fontWeight: 700, fontSize: 18, color: '#333' }}>
                        {flights[0].departure.time}
                      </div>
                      <div style={{ fontSize: 16, color: '#666', fontWeight: 500, marginLeft: "30px" }}>
                        {flights[0].departure.airport} ({flights[0].departure.code})
                      </div>
                    </div>
                  </div>

                  {/* First Flight Duration with Airplane */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '16px',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {/* Airplane Icon */}
                    <div style={{
                      position: 'absolute',
                      left: '-26px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: '16px'
                    }}>
                      <img src={flightIcon} alt="flight" />
                    </div>

                    <div style={{ fontSize: 14, color: '#666' }}>
                      {flights[0].duration}
                    </div>
                  </div>

                  {/* First Arrival */}
                  <div style={{
                    position: 'relative',
                    marginBottom: '8px'
                  }}>
                    {/* Timeline Circle */}
                    <div style={{
                      position: 'absolute',
                      left: '-21px',
                      top: '12px',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      border: '2px solid #ddd',
                      background: '#fff'
                    }}></div>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                      <div style={{ fontWeight: 700, fontSize: 18, color: '#333' }}>
                        {flights[0].arrival.time}
                      </div>
                      <div style={{ fontSize: 16, color: '#666', fontWeight: 500, marginLeft: "30px" }}>
                        {flights[0].arrival.airport} ({flights[0].arrival.code})
                      </div>
                    </div>
                  </div>

                  {/* Layover Information - Only show if there are stops */}
                  {flights[0].stops !== "nonstop" && (
                    <div style={{
                      padding: '8px 0',
                      margin: '8px 0',
                      fontSize: 12,
                      color: '#666',
                      fontWeight: 500,
                      textAlign: 'center',
                      borderBottom: "1px solid #cfd8e3",
                      borderTop: "1px solid #cfd8e3",
                    }}>
                      {flights[0].stops} • Change planes in {flights[0].stopAirport}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Return Card - Only show if there's a return flight */}
            {flights.length > 1 && (
              <div style={{
                background: '#fff',
                borderRadius: 10,
                boxShadow: '0 2px 8px #dbe2ea',
                border: '1px solid #cfd8e3',
                padding: "16px",
                marginBottom: '0'
              }}>
                {/* Return Header */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '16px',
                  padding: '0',
                  borderBottom: '1px solid #dee2e6'
                }}>
                  <div style={{ fontWeight: 600, fontSize: 16, color: '#333' }}>
                    Return • {flights[1].departure.airport} to {flights[1].arrival.airport}
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 14, color: '#666' }}>
                    {flights[1].flightDuration}
                  </div>
                </div>

                {/* Return Flight Segment */}
                <div style={{
                  marginBottom: '0',
                  position: 'relative'
                }}>
                  {/* Flight Header */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '16px'
                  }}>
                    <span style={{
                      color: '#0074d9',
                      fontWeight: 600,
                      fontSize: 14
                    }}>
                      {flights[1].airline}
                    </span>
                    <span style={{ fontSize: 12, color: '#5a6872' }}>
                      {flights[1].flightNumber}
                    </span>
                    <span style={{
                      color: '#666',
                      padding: '4px 12px',
                      borderRadius: '8px',
                      fontSize: 12,
                      fontWeight: 500,
                      border: "1px solid #cfd8e3",
                      marginLeft: "10px",
                    }}>
                      {flights[1].aircraft}
                    </span>

                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'center', position: 'absolute', right: '0', top: '0' }}>
                      <Amenities amenities={mapFlightAmenities(flights[1].amenities)} cabinClass="Basic Economy" />
                    </div>
                  </div>

                  {/* Vertical Timeline Layout */}
                  <div style={{
                    position: 'relative',
                    paddingLeft: '30px'
                  }}>
                    {/* Timeline Line */}
                    <div style={{
                      position: 'absolute',
                      left: '14px',
                      top: '0',
                      bottom: '0',
                      width: '2px',
                      background: '#ddd'
                    }}></div>

                    {/* Departure */}
                    <div style={{
                      position: 'relative',
                      marginBottom: '16px'
                    }}>
                      {/* Timeline Circle */}
                      <div style={{
                        position: 'absolute',
                        left: '-21px',
                        top: '0px',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        border: '2px solid #ddd',
                        background: '#fff'
                      }}></div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                        <div style={{ fontWeight: 700, fontSize: 18, color: '#333' }}>
                          {flights[1].departure.time}
                        </div>
                        <div style={{ fontSize: 16, color: '#666', fontWeight: 500, marginLeft: "30px" }}>
                          {flights[1].departure.airport} ({flights[1].departure.code})
                        </div>
                      </div>
                    </div>

                    {/* First Flight Duration with Airplane */}
                    <div style={{
                      position: 'relative',
                      marginBottom: '16px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      {/* Airplane Icon */}
                      <div style={{
                        position: 'absolute',
                        left: '-26px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        fontSize: '16px'
                      }}>
                        <img src={flightIcon} alt="flight" />
                      </div>

                      <div style={{ fontSize: 14, color: '#666' }}>
                        {flights[1].duration}
                      </div>
                    </div>

                    {/* First Arrival */}
                    <div style={{
                      position: 'relative',
                      marginBottom: '8px'
                    }}>
                      {/* Timeline Circle */}
                      <div style={{
                        position: 'absolute',
                        left: '-21px',
                        top: '12px',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        border: '2px solid #ddd',
                        background: '#fff'
                      }}></div>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
                        <div style={{ fontWeight: 700, fontSize: 18, color: '#333' }}>
                          {flights[1].arrival.time}
                        </div>
                        <div style={{ fontSize: 16, color: '#666', fontWeight: 500, marginLeft: "30px" }}>
                          {flights[1].arrival.airport} ({flights[1].arrival.code})
                        </div>
                      </div>
                    </div>

                    {/* Layover Information - Only show if there are stops */}
                    {flights[1].stops !== "nonstop" && (
                      <div style={{
                        padding: '8px 0',
                        margin: '8px 0',
                        fontSize: 12,
                        color: '#666',
                        fontWeight: 500,
                        textAlign: 'center',
                        borderBottom: "1px solid #cfd8e3",
                        borderTop: "1px solid #cfd8e3",
                      }}>
                        {flights[1].stops} • Change planes in {flights[1].stopAirport}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Price Details Section */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            borderTop: '1px solid #e9ecef',
            background: '#fff'
          }}>
            {/* Left side - Empty for now */}
            <div style={{ flex: 1 }}></div>

            {/* Right side - Pricing and Select Button */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              {/* Deal Count */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: '2px'
              }}>
                <div style={{
                  fontSize: 12,
                  color: '#666',
                  fontWeight: 400
                }}>
                  2 deals from
                </div>

                {/* Price with Info Icon */}
                <div
                  style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '6px' }}
                  onMouseEnter={() => setShowPriceBreakdown(true)}
                  onMouseLeave={() => setShowPriceBreakdown(false)}
                >
                  <div style={{
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    border: '1px solid #333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 10,
                    fontWeight: 600,
                    color: '#333',
                    cursor: 'default'
                  }}>
                    i
                  </div>
                  <div style={{
                    fontSize: 18,
                    fontWeight: 700,
                    color: '#222'
                  }}>
                    {props.price1}
                  </div>

                  {showPriceBreakdown && (
                    <div style={{
                      position: 'absolute',
                      right: 0,
                      bottom: 'calc(100% + 12px)',
                      width: 280,
                      background: '#fff',
                      border: '1px solid #e6e8eb',
                      // borderRadius: 12,
                      boxShadow: '0 12px 28px rgba(0,0,0,0.16)',
                      zIndex: 50,
                      overflow: 'hidden'
                    }}>
                      <div style={{ position: 'absolute', right: '18px', top: '100%', width: 14, height: 14, background: '#fff', borderLeft: '1px solid #e6e8eb', borderBottom: '1px solid #e6e8eb', transform: 'translateY(-2px) rotate(45deg)' }} />

                      <div style={{ padding: '16px 18px' }}>
                        <div style={{ fontWeight: 700, fontSize: 18, color: '#111827', marginBottom: 12 }}>Price breakdown</div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 7a2 2 0 012-2h10l6 6v6a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="#111827" strokeWidth="1.5"/></svg>
                            <span style={{ color: '#374151', fontSize: 14 }}>Ticket price</span>
                          </div>
                          <div style={{ color: '#111827', fontWeight: 400, fontSize: 14 }}>{props.price1 || '$0'}</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <img src={Bag} alt="Carry-on bag" style={{ width: 16, height: 16, filter: 'grayscale(100%) contrast(120%)' }} />
                            <span style={{ color: '#374151', fontSize: 14 }}>Carry-on bag</span>
                          </div>
                          <div style={{ color: '#111827', fontWeight: 400, fontSize: 14 }}>Included</div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <img src={Bag} alt="Checked bag" style={{ width: 16, height: 16, filter: 'grayscale(100%) contrast(120%)' }} />
                            <span style={{ color: '#374151', fontSize: 14 }}>Checked bag</span>
                          </div>
                          <div style={{ textAlign: 'right', color: '#374151' }}>
                            <div style={{ fontWeight: 400, fontSize: 14 }}>Not Included</div>
                            <div style={{ fontSize: 13, color: '#6b7280' }}>(+$70)</div>
                          </div>
                        </div>

                        <div style={{ color: '#6b7280', fontSize: 12, marginTop: 10 }}>Up to 50lbs per bag • Up to 62in total</div>

                        <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '14px 0' }} />

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ color: '#111827', fontWeight: 700, fontSize: 15 }}>Total</div>
                          <div style={{ color: '#111827', fontWeight: 700, fontSize: 15 }}>{props.price1 || '$0'}</div>
                        </div>
                      </div>

                      <div style={{ background: '#f5f7f8', borderTop: '1px solid #e6e8eb', padding: '12px 18px', fontSize: 12, color: '#6b7280' }}>
                        *Baggage fees may be estimated and vary across booking sites.
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Select Button */}
              <button style={{
                background: 'linear-gradient(90deg, #ff690f 0%, #ff8800 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                padding: '10px 20px',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(255, 105, 15, 0.3)'
              }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.02)';
                  e.target.style.boxShadow = '0 4px 8px rgba(255, 105, 15, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 2px 4px rgba(255, 105, 15, 0.3)';
                }}>
                {props.showBestHeader ? 'View deal' : 'Select'}
              </button>
            </div>
          </div>
        </>
      )}


    </div>
  );
}

export default DoubleRateCard;